'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _toastLocal = require('./toast.local.css');

var _toastLocal2 = _interopRequireDefault(_toastLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Toast = function (_Component) {
  _inherits(Toast, _Component);

  function Toast() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Toast);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Toast.__proto__ || Object.getPrototypeOf(Toast)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      mounted: false,
      unmounting: false
    }, _this.beginAutodismissCountdown = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
      if (props.stackBehind) return;

      _this.clearAutodismissCountdown();

      _this.timer = setTimeout(_this.dismissToast, _this.props.autoDismissDelay);
    }, _this.clearAutodismissCountdown = function () {
      clearTimeout(_this.timer);
    }, _this.dismissToast = function () {
      _this.setState(function () {
        return {
          unmounting: true
        };
      });

      setTimeout(function () {
        _this.clearAutodismissCountdown();

        _this.props.dismissToast(_this.props.identifier);
      }, 400);
    }, _this.dismissAndRetry = function () {
      _this.clearAutodismissCountdown();

      _this.props.dismissToast(_this.props.identifier);

      _this.props.retryAction();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  /*
   * Used for animating in and out
   */


  _createClass(Toast, [{
    key: 'componentDidMount',

    /*
     * Helps animate the mounting
     */
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState(function () {
          return {
            mounted: true
          };
        });
      }, 1);
      this.beginAutodismissCountdown();
    }
    /*
     * If the top Toast gets dismissed,
     * we need to start the countdown timer
     * for dismissing this Toast
     */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.stackBehind === true && nextProps.stackBehind === false) {
        this.beginAutodismissCountdown(nextProps);
      }
    }
    /*
     * Helps animate the unmounting
     */

  }, {
    key: 'render',
    value: function render() {
      var _classnames, _classnames2;

      var _props = this.props,
          message = _props.message,
          type = _props.type;
      var toastClassnames = (0, _classnames4.default)(_toastLocal2.default.toast, (_classnames = {}, _defineProperty(_classnames, _toastLocal2.default.mounted, this.state.mounted && !this.state.unmounting), _defineProperty(_classnames, _toastLocal2.default.stack, this.props.stackBehind), _classnames));
      var dismissClassnames = (0, _classnames4.default)(_toastLocal2.default.close, (_classnames2 = {}, _defineProperty(_classnames2, _toastLocal2.default.default, type === 'default'), _defineProperty(_classnames2, _toastLocal2.default.warning, type === 'warning'), _defineProperty(_classnames2, _toastLocal2.default.negative, type === 'negative'), _defineProperty(_classnames2, _toastLocal2.default.positive, type === 'positive'), _classnames2));
      var retry = this.props.retryAction ? // eslint-disable-next-line jsx-a11y/anchor-has-content
      _react2.default.createElement('a', {
        onClick: this.dismissAndRetry,
        role: 'button',
        tabIndex: -1
      }, 'retry') : null;
      return _react2.default.createElement('div', {
        className: toastClassnames,
        onMouseEnter: this.clearAutodismissCountdown,
        onMouseLeave: this.beginAutodismissCountdown
      }, _react2.default.createElement('span', {
        className: _toastLocal2.default.content
      }, message, retry), _react2.default.createElement('span', {
        className: dismissClassnames,
        role: 'button',
        tabIndex: -1,
        'aria-label': 'Close'
      }, _react2.default.createElement(_icon2.default, {
        icon: 'close',
        color: 'light',
        size: 'large',
        onClick: this.dismissToast
      })));
    }
  }]);

  return Toast;
}(_react.Component);

Toast.propTypes = {
  type: _propTypes2.default.oneOf(['warning', 'positive', 'negative', 'default']).isRequired,
  message: _propTypes2.default.string.isRequired,
  identifier: _propTypes2.default.string.isRequired,
  dismissToast: _propTypes2.default.func.isRequired,
  autoDismissDelay: _propTypes2.default.number.isRequired,
  stackBehind: _propTypes2.default.bool.isRequired,
  retryAction: _propTypes2.default.func
};
Toast.defaultProps = {
  type: 'default',
  autoDismissDelay: 7000,
  stackBehind: false
};
exports.default = Toast;